import { useState, useCallback } from 'react';
import { ITradesValues } from '../types';

interface IUseOtherTradesProps {
  values: ITradesValues;
  setValue: (key: keyof ITradesValues, value: any) => void;
  otherTrades: { id?: string };
}

/**
 * Custom hook for managing other trades selection and toggling
 *
 * @param {IUseOtherTradesProps} props - Props containing form values, setValue function, and other trades data
 * @returns {Object} Object containing other trade selection state and toggle handler
 */
export const useOtherTrades = ({ values, setValue, otherTrades }: IUseOtherTradesProps) => {
  const [isOtherTradeSelected, setOtherTradeSelected] = useState(false);

  const handleToggleOtherTrade = useCallback(() => {
    const tradeKey = 'trades' as keyof ITradesValues;

    if (isOtherTradeSelected) {
      // Remove other trade from selection
      const updatedTrades = values.trades.filter(trade => trade !== otherTrades?.id);
      setValue(tradeKey, updatedTrades);
    } else {
      // Add other trade to selection
      const updatedTrades = Array.isArray(values.trades) ? [...values.trades, otherTrades?.id] : [otherTrades?.id];
      setValue(tradeKey, updatedTrades);
    }

    setOtherTradeSelected(prev => !prev);
  }, [values.trades, otherTrades?.id, isOtherTradeSelected, setValue]);

  return {
    isOtherTradeSelected,
    handleToggleOtherTrade,
  };
};
